// Theme constants extracted from prototypes/dashboard-prototype.jsx.
// THEMES, THEME_VARIATIONS, THEME_ORDER, DENSITY_MODES, applyVariation.

export const THEMES = {
  'fantasy-classic': {
    id: 'fantasy-classic',
    name: 'Classic Fantasy',
    description: 'The original BMG look — parchment & gold',
    category: 'fantasy',
    preview: '🏰',
    order: 1,
    colors: {
      bgPrimary: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      bgSecondary: '#1a1a2e',
      bgCard: 'linear-gradient(180deg, rgba(42,32,24,0.98) 0%, rgba(32,24,18,0.99) 100%)',
      bgCardSolid: '#2a2018',
      bgCardHover: '#3a3028',
      bgInput: 'rgba(18,14,10,0.95)',
      bgHover: 'rgba(201,162,39,0.2)',
      bgModal: 'rgba(0,0,0,0.85)',
      accent: '#c9a227',
      accentLight: '#ffd700',
      accentDark: '#8b6914',
      accentGlow: 'rgba(201,162,39,0.4)',
      success: '#27c95a',
      successBg: 'rgba(39,201,90,0.25)',
      danger: '#c92727',
      dangerBg: 'rgba(201,39,39,0.25)',
      warning: '#c9a227',
      warningBg: 'rgba(201,162,39,0.25)',
      info: '#4a90d9',
      infoBg: 'rgba(74,144,217,0.25)',
      mana: '#4a90d9',
      manaBg: 'rgba(26,74,139,0.4)',
      textPrimary: '#e8d5b7',
      textSecondary: '#b89a70',
      textMuted: '#7a6a55',
      textOnAccent: '#000000',
      borderPrimary: '#5c4a2a',
      borderLight: '#3a3020',
      borderAccent: '#c9a227',
      hpHigh: '#27c95a',
      hpMid: '#c9a227',
      hpLow: '#c92727',
      buffBg: 'rgba(39,201,90,0.35)',
      buffBorder: '#27c95a',
      buffText: '#7dff7d',
      debuffBg: 'rgba(201,39,39,0.35)',
      debuffBorder: '#c92727',
      debuffText: '#ff7d7d',
    },
    typography: {
      fontFamily: 'Georgia, "Times New Roman", serif',
      headingFamily: 'Georgia, serif',
      monoFamily: '"Courier New", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.6), 0 0 1px rgba(201,162,39,0.3)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.7), 0 0 20px rgba(201,162,39,0.2)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 20px rgba(201,162,39,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '8px',
      borderRadiusLg: '12px',
      borderRadiusSm: '4px',
      borderWidth: '2px',
      cardBorder: '2px solid #5c4a2a',
      inputBorder: '1px solid #3a3020',
      transition: 'all 0.2s ease',
    },
  },

  'fantasy-dark': {
    id: 'fantasy-dark',
    name: 'Dark Arcana',
    description: 'Mystical purples and deep shadows',
    category: 'fantasy',
    preview: '🔮',
    colors: {
      bgPrimary: '#000001',
      bgSecondary: '#000000',
      bgCard: 'linear-gradient(180deg, rgba(58,38,82,0.98) 0%, rgba(45,28,65,0.99) 100%)',
      bgCardSolid: '#1c1028',
      bgCardHover: '#281838',
      bgInput: 'rgba(25,15,38,0.95)',
      bgHover: 'rgba(155,89,182,0.2)',
      bgModal: 'rgba(0,0,0,0.9)',
      accent: '#9b59b6',
      accentLight: '#d4a5ff',
      accentDark: '#6b3fa0',
      accentGlow: 'rgba(155,89,182,0.5)',
      success: '#00d9a0',
      successBg: 'rgba(0,217,160,0.25)',
      danger: '#ff4757',
      dangerBg: 'rgba(255,71,87,0.25)',
      warning: '#ffa502',
      warningBg: 'rgba(255,165,2,0.25)',
      info: '#70a1ff',
      infoBg: 'rgba(112,161,255,0.25)',
      mana: '#9b59b6',
      manaBg: 'rgba(155,89,182,0.4)',
      textPrimary: '#d8d0e8',
      textSecondary: '#a090c0',
      textMuted: '#7060a0',
      textOnAccent: '#ffffff',
      borderPrimary: '#7b4fa6',
      borderLight: '#4d2070',
      borderAccent: '#b06ed8',
      hpHigh: '#00d9a0',
      hpMid: '#ffa502',
      hpLow: '#ff4757',
      buffBg: 'rgba(0,217,160,0.35)',
      buffBorder: '#00d9a0',
      buffText: '#7dffda',
      debuffBg: 'rgba(255,71,87,0.35)',
      debuffBorder: '#ff4757',
      debuffText: '#ff9da4',
    },
    typography: {
      fontFamily: '"Palatino Linotype", "Book Antiqua", Palatino, serif',
      headingFamily: '"Palatino Linotype", serif',
      monoFamily: '"Fira Code", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.6), 0 0 30px rgba(155,89,182,0.15)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.7), 0 0 40px rgba(155,89,182,0.25)',
      buttonShadow: '0 2px 8px rgba(155,89,182,0.3)',
      glowAccent: '0 0 30px rgba(155,89,182,0.5)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '12px',
      borderRadiusLg: '16px',
      borderRadiusSm: '6px',
      borderWidth: '2px',
      cardBorder: '2px solid #7b4fa6',
      inputBorder: '1px solid #4d2070',
      transition: 'all 0.25s ease',
    },
  },

  'fantasy-nature': {
    id: 'fantasy-nature',
    name: 'Verdant Grove',
    description: 'Forest greens and warm earth tones',
    category: 'fantasy',
    preview: '🌿',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #140804 0%, #201008 50%, #180a04 100%)',
      bgSecondary: '#0a0402',
      bgCard: 'linear-gradient(180deg, rgba(60,45,30,0.98) 0%, rgba(48,35,22,0.99) 100%)',
      bgCardSolid: '#3c2d1e',
      bgCardHover: '#4d3c2a',
      bgInput: 'rgba(30,22,14,0.95)',
      bgHover: 'rgba(224,136,48,0.2)',
      bgModal: 'rgba(0,0,0,0.85)',
      accent: '#e08830',
      accentLight: '#f0a850',
      accentDark: '#b06820',
      accentGlow: 'rgba(224,136,48,0.4)',
      success: '#7ddb8a',
      successBg: 'rgba(125,219,138,0.25)',
      danger: '#e74c3c',
      dangerBg: 'rgba(231,76,60,0.25)',
      warning: '#d4a84b',
      warningBg: 'rgba(212,168,75,0.25)',
      info: '#5dade2',
      infoBg: 'rgba(93,173,226,0.25)',
      mana: '#5dade2',
      manaBg: 'rgba(93,173,226,0.35)',
      textPrimary: '#fff0d0',
      textSecondary: '#e8c080',
      textMuted: '#a08050',
      textOnAccent: '#000000',
      borderPrimary: '#6a4a2a',
      borderLight: '#4a3520',
      borderAccent: '#e08830',
      hpHigh: '#7ddb8a',
      hpMid: '#d4a84b',
      hpLow: '#e74c3c',
      buffBg: 'rgba(125,219,138,0.35)',
      buffBorder: '#7ddb8a',
      buffText: '#a5ffb0',
      debuffBg: 'rgba(231,76,60,0.35)',
      debuffBorder: '#e74c3c',
      debuffText: '#ff9d94',
    },
    typography: {
      fontFamily: '"Trebuchet MS", "Lucida Sans", Arial, sans-serif',
      headingFamily: '"Trebuchet MS", sans-serif',
      monoFamily: 'Consolas, monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(224,136,48,0.1)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 30px rgba(224,136,48,0.15)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.3)',
      glowAccent: '0 0 20px rgba(224,136,48,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '10px',
      borderRadiusLg: '14px',
      borderRadiusSm: '5px',
      borderWidth: '2px',
      cardBorder: '2px solid #6a4a2a',
      inputBorder: '1px solid #4a3520',
      transition: 'all 0.2s ease',
    },
  },

  'sunset-dusk': {
    id: 'sunset-dusk',
    name: 'Sunset Dusk',
    description: 'Warm oranges flowing into cool purples',
    category: 'multicolor',
    preview: '🌅',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #080406 0%, #0c0608 50%, #080504 100%)',
      bgSecondary: '#050304',
      bgCard: 'linear-gradient(145deg, rgba(60,30,50,0.98) 0%, rgba(50,25,35,0.99) 100%)',
      bgCardSolid: '#3c1e32',
      bgCardHover: '#4d2840',
      bgInput: 'rgba(30,15,25,0.95)',
      bgHover: 'rgba(255,140,90,0.2)',
      bgModal: 'rgba(0,0,0,0.9)',
      accent: '#ff8c5a',
      accentLight: '#ffb088',
      accentDark: '#d96830',
      accentGlow: 'rgba(255,140,90,0.4)',
      success: '#7dd87d',
      successBg: 'rgba(125,216,125,0.25)',
      danger: '#ff6b8a',
      dangerBg: 'rgba(255,107,138,0.25)',
      warning: '#ffc145',
      warningBg: 'rgba(255,193,69,0.25)',
      info: '#a78bfa',
      infoBg: 'rgba(167,139,250,0.25)',
      mana: '#c084fc',
      manaBg: 'rgba(192,132,252,0.3)',
      textPrimary: '#fef0e8',
      textSecondary: '#e8c0b8',
      textMuted: '#a88090',
      textOnAccent: '#1a0a10',
      borderPrimary: '#8b4060',
      borderLight: '#5a2840',
      borderAccent: '#ff8c5a',
      hpHigh: '#7dd87d',
      hpMid: '#ffc145',
      hpLow: '#ff6b8a',
      buffBg: 'rgba(125,216,125,0.35)',
      buffBorder: '#7dd87d',
      buffText: '#a8f0a8',
      debuffBg: 'rgba(255,107,138,0.35)',
      debuffBorder: '#ff6b8a',
      debuffText: '#ffa0b8',
    },
    typography: {
      fontFamily: '"Segoe UI", Tahoma, Geneva, sans-serif',
      headingFamily: '"Segoe UI", sans-serif',
      monoFamily: '"Cascadia Code", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(255,140,90,0.1)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 30px rgba(255,140,90,0.2)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 25px rgba(255,140,90,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '10px',
      borderRadiusLg: '14px',
      borderRadiusSm: '6px',
      borderWidth: '2px',
      cardBorder: '2px solid #8b4060',
      inputBorder: '1px solid #5a2840',
      transition: 'all 0.2s ease',
    },
  },

  'ocean-depths': {
    id: 'ocean-depths',
    name: 'Ocean Depths',
    description: 'Deep navy with teal and coral accents',
    category: 'multicolor',
    preview: '🌊',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #030a12 0%, #051520 50%, #0a1a25 100%)',
      bgSecondary: '#020810',
      bgCard: 'linear-gradient(145deg, rgba(15,50,70,0.98) 0%, rgba(10,35,55,0.99) 100%)',
      bgCardSolid: '#0f3246',
      bgCardHover: '#154055',
      bgInput: 'rgba(8,25,40,0.95)',
      bgHover: 'rgba(80,220,200,0.15)',
      bgModal: 'rgba(0,5,10,0.9)',
      accent: '#50dcc8',
      accentLight: '#80ffe8',
      accentDark: '#30b0a0',
      accentGlow: 'rgba(80,220,200,0.4)',
      success: '#50dcc8',
      successBg: 'rgba(80,220,200,0.25)',
      danger: '#ff7088',
      dangerBg: 'rgba(255,112,136,0.25)',
      warning: '#ffd070',
      warningBg: 'rgba(255,208,112,0.25)',
      info: '#70b0ff',
      infoBg: 'rgba(112,176,255,0.25)',
      mana: '#70b0ff',
      manaBg: 'rgba(112,176,255,0.3)',
      textPrimary: '#f0fcff',
      textSecondary: '#c0e8f8',
      textMuted: '#80c0d8',
      textOnAccent: '#051520',
      borderPrimary: '#206080',
      borderLight: '#104060',
      borderAccent: '#50dcc8',
      hpHigh: '#50dcc8',
      hpMid: '#ffd070',
      hpLow: '#ff7088',
      buffBg: 'rgba(80,220,200,0.35)',
      buffBorder: '#50dcc8',
      buffText: '#a0fff0',
      debuffBg: 'rgba(255,112,136,0.35)',
      debuffBorder: '#ff7088',
      debuffText: '#ffa8b8',
    },
    typography: {
      fontFamily: '"Source Sans Pro", "Helvetica Neue", sans-serif',
      headingFamily: '"Source Sans Pro", sans-serif',
      monoFamily: '"Source Code Pro", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(80,220,200,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 35px rgba(80,220,200,0.15)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 25px rgba(80,220,200,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '10px',
      borderRadiusLg: '14px',
      borderRadiusSm: '5px',
      borderWidth: '2px',
      cardBorder: '2px solid #206080',
      inputBorder: '1px solid #104060',
      transition: 'all 0.2s ease',
    },
  },

  'northern-lights': {
    id: 'northern-lights',
    name: 'Northern Lights',
    description: 'Aurora greens, blues, and magentas',
    category: 'multicolor',
    preview: '🌌',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #020510 0%, #050818 50%, #080515 100%)',
      bgSecondary: '#010308',
      bgCard: 'linear-gradient(145deg, rgba(20,35,60,0.97) 0%, rgba(15,25,45,0.98) 100%)',
      bgCardSolid: '#14233c',
      bgCardHover: '#1c3050',
      bgInput: 'rgba(10,18,35,0.95)',
      bgHover: 'rgba(100,255,180,0.15)',
      bgModal: 'rgba(0,2,8,0.92)',
      accent: '#64ffb4',
      accentLight: '#a0ffd0',
      accentDark: '#40d090',
      accentGlow: 'rgba(100,255,180,0.4)',
      success: '#64ffb4',
      successBg: 'rgba(100,255,180,0.25)',
      danger: '#ff70a0',
      dangerBg: 'rgba(255,112,160,0.25)',
      warning: '#ffe064',
      warningBg: 'rgba(255,224,100,0.25)',
      info: '#64b4ff',
      infoBg: 'rgba(100,180,255,0.25)',
      mana: '#c890ff',
      manaBg: 'rgba(200,144,255,0.3)',
      textPrimary: '#f0faff',
      textSecondary: '#b0d8e8',
      textMuted: '#7098b0',
      textOnAccent: '#051510',
      borderPrimary: '#305080',
      borderLight: '#203858',
      borderAccent: '#64ffb4',
      hpHigh: '#64ffb4',
      hpMid: '#ffe064',
      hpLow: '#ff70a0',
      buffBg: 'rgba(100,255,180,0.35)',
      buffBorder: '#64ffb4',
      buffText: '#a8ffd8',
      debuffBg: 'rgba(255,112,160,0.35)',
      debuffBorder: '#ff70a0',
      debuffText: '#ffa8c8',
    },
    typography: {
      fontFamily: 'Raleway, "Segoe UI", sans-serif',
      headingFamily: 'Raleway, sans-serif',
      monoFamily: '"Fira Code", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.6), 0 0 25px rgba(100,255,180,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.7), 0 0 40px rgba(100,255,180,0.15)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 30px rgba(100,255,180,0.5)',
      textShadow: '0 1px 3px rgba(0,0,0,0.6)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.7)',
      borderRadius: '12px',
      borderRadiusLg: '16px',
      borderRadiusSm: '6px',
      borderWidth: '2px',
      cardBorder: '2px solid #305080',
      inputBorder: '1px solid #203858',
      transition: 'all 0.25s ease',
    },
  },

  'copper-teal': {
    id: 'copper-teal',
    name: 'Copper & Teal',
    description: 'Steampunk-inspired warm copper with cool teal',
    category: 'multicolor',
    preview: '⚙️',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #0a0806 0%, #100c08 50%, #0c0a06 100%)',
      bgSecondary: '#060504',
      bgCard: 'linear-gradient(145deg, rgba(35,55,55,0.98) 0%, rgba(25,42,42,0.99) 100%)',
      bgCardSolid: '#233737',
      bgCardHover: '#2e4545',
      bgInput: 'rgba(15,28,28,0.95)',
      bgHover: 'rgba(210,140,90,0.2)',
      bgModal: 'rgba(5,10,10,0.9)',
      accent: '#d28c5a',
      accentLight: '#e8b088',
      accentDark: '#a86830',
      accentGlow: 'rgba(210,140,90,0.4)',
      success: '#5ac8b8',
      successBg: 'rgba(90,200,184,0.25)',
      danger: '#d86060',
      dangerBg: 'rgba(216,96,96,0.25)',
      warning: '#d2a85a',
      warningBg: 'rgba(210,168,90,0.25)',
      info: '#5aa8d2',
      infoBg: 'rgba(90,168,210,0.25)',
      mana: '#5ac8b8',
      manaBg: 'rgba(90,200,184,0.3)',
      textPrimary: '#f0ece8',
      textSecondary: '#c8beb8',
      textMuted: '#8a8580',
      textOnAccent: '#0a0805',
      borderPrimary: '#4a6868',
      borderLight: '#304545',
      borderAccent: '#d28c5a',
      hpHigh: '#5ac8b8',
      hpMid: '#d2a85a',
      hpLow: '#d86060',
      buffBg: 'rgba(90,200,184,0.35)',
      buffBorder: '#5ac8b8',
      buffText: '#98e8d8',
      debuffBg: 'rgba(216,96,96,0.35)',
      debuffBorder: '#d86060',
      debuffText: '#f0a0a0',
    },
    typography: {
      fontFamily: '"Crimson Text", Georgia, serif',
      headingFamily: '"Crimson Text", serif',
      monoFamily: '"Courier Prime", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 15px rgba(210,140,90,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 25px rgba(210,140,90,0.15)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 20px rgba(210,140,90,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '6px',
      borderRadiusLg: '10px',
      borderRadiusSm: '4px',
      borderWidth: '2px',
      cardBorder: '2px solid #4a6868',
      inputBorder: '1px solid #304545',
      transition: 'all 0.2s ease',
    },
  },

  'sakura': {
    id: 'sakura',
    name: 'Sakura',
    description: 'Soft cherry blossom pinks with lavender accents',
    category: 'multicolor',
    preview: '🌸',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #0c0610 0%, #100814 50%, #0c060f 100%)',
      bgSecondary: '#080408',
      bgCard: 'linear-gradient(145deg, rgba(55,30,50,0.98) 0%, rgba(45,25,42,0.99) 100%)',
      bgCardSolid: '#3a2035',
      bgCardHover: '#482840',
      bgInput: 'rgba(28,15,25,0.95)',
      bgHover: 'rgba(255,180,200,0.2)',
      bgModal: 'rgba(10,5,12,0.9)',
      accent: '#ffb4c8',
      accentLight: '#ffd8e4',
      accentDark: '#d88aa0',
      accentGlow: 'rgba(255,180,200,0.4)',
      success: '#98d8a8',
      successBg: 'rgba(152,216,168,0.25)',
      danger: '#e07080',
      dangerBg: 'rgba(224,112,128,0.25)',
      warning: '#e8c878',
      warningBg: 'rgba(232,200,120,0.25)',
      info: '#b8a8e8',
      infoBg: 'rgba(184,168,232,0.25)',
      mana: '#c8a8e8',
      manaBg: 'rgba(200,168,232,0.3)',
      textPrimary: '#f8f0ff',
      textSecondary: '#e0c8e8',
      textMuted: '#a888b8',
      textOnAccent: '#200810',
      borderPrimary: '#804058',
      borderLight: '#502838',
      borderAccent: '#ffb4c8',
      hpHigh: '#98d8a8',
      hpMid: '#e8c878',
      hpLow: '#e07080',
      buffBg: 'rgba(152,216,168,0.35)',
      buffBorder: '#98d8a8',
      buffText: '#c0f0c8',
      debuffBg: 'rgba(224,112,128,0.35)',
      debuffBorder: '#e07080',
      debuffText: '#f8a0b0',
    },
    typography: {
      fontFamily: '"Noto Serif", Georgia, serif',
      headingFamily: '"Noto Serif", serif',
      monoFamily: '"Noto Sans Mono", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(255,180,200,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 30px rgba(255,180,200,0.15)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 25px rgba(255,180,200,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '12px',
      borderRadiusLg: '16px',
      borderRadiusSm: '6px',
      borderWidth: '2px',
      cardBorder: '2px solid #804058',
      inputBorder: '1px solid #502838',
      transition: 'all 0.2s ease',
    },
  },

  'royal-court': {
    id: 'royal-court',
    name: 'Royal Court',
    description: 'Regal navy and gold with burgundy accents',
    category: 'multicolor',
    preview: '👑',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #06060f 0%, #080814 50%, #0a050c 100%)',
      bgSecondary: '#040408',
      bgCard: 'linear-gradient(145deg, rgba(30,30,65,0.98) 0%, rgba(22,22,50,0.99) 100%)',
      bgCardSolid: '#1e1e41',
      bgCardHover: '#282855',
      bgInput: 'rgba(15,15,35,0.95)',
      bgHover: 'rgba(218,175,85,0.2)',
      bgModal: 'rgba(5,5,15,0.92)',
      accent: '#daaf55',
      accentLight: '#f0d080',
      accentDark: '#b08830',
      accentGlow: 'rgba(218,175,85,0.4)',
      success: '#55b888',
      successBg: 'rgba(85,184,136,0.25)',
      danger: '#c85565',
      dangerBg: 'rgba(200,85,101,0.25)',
      warning: '#daaf55',
      warningBg: 'rgba(218,175,85,0.25)',
      info: '#5588c8',
      infoBg: 'rgba(85,136,200,0.25)',
      mana: '#8870c8',
      manaBg: 'rgba(136,112,200,0.3)',
      textPrimary: '#f8f5f0',
      textSecondary: '#c8c0b8',
      textMuted: '#888088',
      textOnAccent: '#0a0810',
      borderPrimary: '#484878',
      borderLight: '#303055',
      borderAccent: '#daaf55',
      hpHigh: '#55b888',
      hpMid: '#daaf55',
      hpLow: '#c85565',
      buffBg: 'rgba(85,184,136,0.35)',
      buffBorder: '#55b888',
      buffText: '#90e8b8',
      debuffBg: 'rgba(200,85,101,0.35)',
      debuffBorder: '#c85565',
      debuffText: '#f0a0a8',
    },
    typography: {
      fontFamily: '"Libre Baskerville", "Times New Roman", serif',
      headingFamily: '"Libre Baskerville", serif',
      monoFamily: '"IBM Plex Mono", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 15px rgba(218,175,85,0.1)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 30px rgba(218,175,85,0.18)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 25px rgba(218,175,85,0.45)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '8px',
      borderRadiusLg: '12px',
      borderRadiusSm: '4px',
      borderWidth: '2px',
      cardBorder: '2px solid #484878',
      inputBorder: '1px solid #303055',
      transition: 'all 0.2s ease',
    },
  },

  'ember-frost': {
    id: 'ember-frost',
    name: 'Ember & Frost',
    description: 'Fire reds against icy blues',
    category: 'multicolor',
    preview: '🔥',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #080608 0%, #0c080a 50%, #08080c 100%)',
      bgSecondary: '#040405',
      bgCard: 'linear-gradient(145deg, rgba(40,32,45,0.98) 0%, rgba(30,25,35,0.99) 100%)',
      bgCardSolid: '#28202d',
      bgCardHover: '#352a3a',
      bgInput: 'rgba(22,18,28,0.95)',
      bgHover: 'rgba(255,120,70,0.2)',
      bgModal: 'rgba(5,5,8,0.92)',
      accent: '#ff7846',
      accentLight: '#ffa080',
      accentDark: '#d05020',
      accentGlow: 'rgba(255,120,70,0.4)',
      success: '#46d8b8',
      successBg: 'rgba(70,216,184,0.25)',
      danger: '#ff6070',
      dangerBg: 'rgba(255,96,112,0.25)',
      warning: '#ffb846',
      warningBg: 'rgba(255,184,70,0.25)',
      info: '#46a8ff',
      infoBg: 'rgba(70,168,255,0.25)',
      mana: '#46a8ff',
      manaBg: 'rgba(70,168,255,0.3)',
      textPrimary: '#f8f4f8',
      textSecondary: '#d0c0d0',
      textMuted: '#9080a0',
      textOnAccent: '#100505',
      borderPrimary: '#605070',
      borderLight: '#403548',
      borderAccent: '#ff7846',
      hpHigh: '#46d8b8',
      hpMid: '#ffb846',
      hpLow: '#ff6070',
      buffBg: 'rgba(70,216,184,0.35)',
      buffBorder: '#46d8b8',
      buffText: '#88f8e0',
      debuffBg: 'rgba(255,96,112,0.35)',
      debuffBorder: '#ff6070',
      debuffText: '#ffa0a8',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, sans-serif',
      headingFamily: '"Inter", sans-serif',
      monoFamily: '"JetBrains Mono", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 15px rgba(255,120,70,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 25px rgba(255,120,70,0.15)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.4)',
      glowAccent: '0 0 25px rgba(255,120,70,0.45)',
      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '10px',
      borderRadiusLg: '14px',
      borderRadiusSm: '5px',
      borderWidth: '2px',
      cardBorder: '2px solid #605070',
      inputBorder: '1px solid #403548',
      transition: 'all 0.2s ease',
    },
  },

  'desert-oasis': {
    id: 'desert-oasis',
    name: 'Desert Oasis',
    description: 'Warm sandy tans with cool turquoise pools',
    category: 'multicolor',
    preview: '🏜️',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #080a08 0%, #0c100c 50%, #0a0e0a 100%)',
      bgSecondary: '#050605',
      bgCard: 'linear-gradient(145deg, rgba(55,48,40,0.98) 0%, rgba(45,40,35,0.99) 100%)',
      bgCardSolid: '#3d3530',
      bgCardHover: '#4d4540',
      bgInput: 'rgba(30,26,22,0.95)',
      bgHover: 'rgba(80,200,180,0.2)',
      bgModal: 'rgba(0,0,0,0.9)',
      accent: '#50c8b4',
      accentLight: '#78e0d0',
      accentDark: '#30a090',
      accentGlow: 'rgba(80,200,180,0.4)',
      success: '#78c890',
      successBg: 'rgba(120,200,144,0.25)',
      danger: '#d87868',
      dangerBg: 'rgba(216,120,104,0.25)',
      warning: '#e0b860',
      warningBg: 'rgba(224,184,96,0.25)',
      info: '#60a8c8',
      infoBg: 'rgba(96,168,200,0.25)',
      mana: '#60a8c8',
      manaBg: 'rgba(96,168,200,0.3)',
      textPrimary: '#f8f4e8',
      textSecondary: '#d8c8b0',
      textMuted: '#a09080',
      textOnAccent: '#101210',
      borderPrimary: '#686050',
      borderLight: '#484038',
      borderAccent: '#50c8b4',
      hpHigh: '#78c890',
      hpMid: '#e0b860',
      hpLow: '#d87868',
      buffBg: 'rgba(120,200,144,0.35)',
      buffBorder: '#78c890',
      buffText: '#a8f0c0',
      debuffBg: 'rgba(216,120,104,0.35)',
      debuffBorder: '#d87868',
      debuffText: '#f0b0a0',
    },
    typography: {
      fontFamily: '"Merriweather Sans", "Segoe UI", sans-serif',
      headingFamily: '"Merriweather Sans", sans-serif',
      monoFamily: '"Inconsolata", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.45), 0 0 15px rgba(80,200,180,0.06)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.55), 0 0 25px rgba(80,200,180,0.12)',
      buttonShadow: '0 2px 8px rgba(80,200,180,0.2)',
      glowAccent: '0 0 20px rgba(80,200,180,0.35)',
      textShadow: '0 1px 2px rgba(0,0,0,0.4)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.5)',
      borderRadius: '8px',
      borderRadiusLg: '12px',
      borderRadiusSm: '4px',
      borderWidth: '2px',
      cardBorder: '2px solid #686050',
      inputBorder: '1px solid #484038',
      transition: 'all 0.2s ease',
    },
  },

  'enchanted-forest': {
    id: 'enchanted-forest',
    name: 'Enchanted Forest',
    description: 'Deep teals with mystical purples and gold fireflies',
    category: 'multicolor',
    preview: '🧚',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #060808 0%, #080c0c 50%, #06090a 100%)',
      bgSecondary: '#040505',
      bgCard: 'linear-gradient(145deg, rgba(25,48,50,0.98) 0%, rgba(22,40,45,0.99) 100%)',
      bgCardSolid: '#1e3840',
      bgCardHover: '#284850',
      bgInput: 'rgba(15,28,30,0.95)',
      bgHover: 'rgba(200,180,100,0.2)',
      bgModal: 'rgba(0,0,0,0.9)',
      accent: '#c8b464',
      accentLight: '#e0d090',
      accentDark: '#a08840',
      accentGlow: 'rgba(200,180,100,0.45)',
      success: '#50c0a0',
      successBg: 'rgba(80,192,160,0.25)',
      danger: '#c86880',
      dangerBg: 'rgba(200,104,128,0.25)',
      warning: '#c8b464',
      warningBg: 'rgba(200,180,100,0.25)',
      info: '#6890c8',
      infoBg: 'rgba(104,144,200,0.25)',
      mana: '#9078c8',
      manaBg: 'rgba(144,120,200,0.3)',
      textPrimary: '#e8f0f0',
      textSecondary: '#a8c8c8',
      textMuted: '#689090',
      textOnAccent: '#101510',
      borderPrimary: '#386058',
      borderLight: '#284540',
      borderAccent: '#c8b464',
      hpHigh: '#50c0a0',
      hpMid: '#c8b464',
      hpLow: '#c86880',
      buffBg: 'rgba(80,192,160,0.35)',
      buffBorder: '#50c0a0',
      buffText: '#88f0d0',
      debuffBg: 'rgba(200,104,128,0.35)',
      debuffBorder: '#c86880',
      debuffText: '#f0a8b8',
    },
    typography: {
      fontFamily: '"Cinzel", Georgia, serif',
      headingFamily: '"Cinzel", serif',
      monoFamily: '"Fira Code", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(200,180,100,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 35px rgba(200,180,100,0.18)',
      buttonShadow: '0 2px 8px rgba(200,180,100,0.3)',
      glowAccent: '0 0 25px rgba(200,180,100,0.45)',
      textShadow: '0 1px 3px rgba(0,0,0,0.5)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.6)',
      borderRadius: '10px',
      borderRadiusLg: '14px',
      borderRadiusSm: '5px',
      borderWidth: '2px',
      cardBorder: '2px solid #386058',
      inputBorder: '1px solid #284540',
      transition: 'all 0.25s ease',
    },
  },

  'mint-chocolate': {
    id: 'mint-chocolate',
    name: 'Mint Chocolate',
    description: 'Fresh cool mints with warm chocolatey browns',
    category: 'multicolor',
    preview: '🍫',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #060808 0%, #080c0c 50%, #060909 100%)',
      bgSecondary: '#040505',
      bgCard: 'linear-gradient(145deg, rgba(48,38,32,0.98) 0%, rgba(40,32,28,0.99) 100%)',
      bgCardSolid: '#362a24',
      bgCardHover: '#463830',
      bgInput: 'rgba(28,22,18,0.95)',
      bgHover: 'rgba(100,220,180,0.2)',
      bgModal: 'rgba(0,0,0,0.9)',
      accent: '#64dcb4',
      accentLight: '#90f0d0',
      accentDark: '#40b890',
      accentGlow: 'rgba(100,220,180,0.4)',
      success: '#64dcb4',
      successBg: 'rgba(100,220,180,0.25)',
      danger: '#dc7878',
      dangerBg: 'rgba(220,120,120,0.25)',
      warning: '#dcc878',
      warningBg: 'rgba(220,200,120,0.25)',
      info: '#78b4dc',
      infoBg: 'rgba(120,180,220,0.25)',
      mana: '#78b4dc',
      manaBg: 'rgba(120,180,220,0.3)',
      textPrimary: '#f8f4f0',
      textSecondary: '#d8c8c0',
      textMuted: '#a09088',
      textOnAccent: '#101410',
      borderPrimary: '#5a4840',
      borderLight: '#3a302a',
      borderAccent: '#64dcb4',
      hpHigh: '#64dcb4',
      hpMid: '#dcc878',
      hpLow: '#dc7878',
      buffBg: 'rgba(100,220,180,0.35)',
      buffBorder: '#64dcb4',
      buffText: '#a0ffd8',
      debuffBg: 'rgba(220,120,120,0.35)',
      debuffBorder: '#dc7878',
      debuffText: '#f8b8b8',
    },
    typography: {
      fontFamily: '"Poppins", "Segoe UI", sans-serif',
      headingFamily: '"Poppins", sans-serif',
      monoFamily: '"Fira Code", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 15px rgba(100,220,180,0.06)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.6), 0 0 25px rgba(100,220,180,0.12)',
      buttonShadow: '0 2px 8px rgba(100,220,180,0.25)',
      glowAccent: '0 0 22px rgba(100,220,180,0.4)',
      textShadow: '0 1px 2px rgba(0,0,0,0.45)',
      headingTextShadow: '0 2px 4px rgba(0,0,0,0.55)',
      borderRadius: '12px',
      borderRadiusLg: '16px',
      borderRadiusSm: '6px',
      borderWidth: '2px',
      cardBorder: '2px solid #5a4840',
      inputBorder: '1px solid #3a302a',
      transition: 'all 0.2s ease',
    },
  },

  'pro-dark': {
    id: 'pro-dark',
    name: 'Professional Dark',
    description: 'Sleek dark mode for focused sessions',
    category: 'professional',
    preview: '🌙',
    colors: {
      bgPrimary: '#020204',
      bgSecondary: '#010102',
      bgCard: '#0c0c10',
      bgCardSolid: '#101018',
      bgCardHover: '#181820',
      bgInput: '#08080c',
      bgHover: 'rgba(59,130,246,0.15)',
      bgModal: 'rgba(0,0,0,0.9)',
      accent: '#3b82f6',
      accentLight: '#60a5fa',
      accentDark: '#2563eb',
      accentGlow: 'rgba(59,130,246,0.3)',
      success: '#34d399',
      successBg: 'rgba(52,211,153,0.2)',
      danger: '#f87171',
      dangerBg: 'rgba(248,113,113,0.2)',
      warning: '#fbbf24',
      warningBg: 'rgba(251,191,36,0.2)',
      info: '#60a5fa',
      infoBg: 'rgba(96,165,250,0.2)',
      mana: '#a78bfa',
      manaBg: 'rgba(167,139,250,0.2)',
      textPrimary: '#f8fafc',
      textSecondary: '#b0c4de',
      textMuted: '#7a9bc0',
      textOnAccent: '#ffffff',
      borderPrimary: '#282830',
      borderLight: '#1c1c24',
      borderAccent: '#3b82f6',
      hpHigh: '#34d399',
      hpMid: '#fbbf24',
      hpLow: '#f87171',
      buffBg: 'rgba(52,211,153,0.25)',
      buffBorder: '#34d399',
      buffText: '#6ee7b7',
      debuffBg: 'rgba(248,113,113,0.25)',
      debuffBorder: '#f87171',
      debuffText: '#fca5a5',
    },
    typography: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      headingFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      monoFamily: 'ui-monospace, "SF Mono", Monaco, monospace',
    },
    effects: {
      cardShadow: '0 4px 16px rgba(0,0,0,0.4), 0 0 1px rgba(59,130,246,0.1)',
      cardShadowHover: '0 8px 24px rgba(0,0,0,0.5), 0 0 20px rgba(59,130,246,0.1)',
      buttonShadow: '0 2px 4px rgba(0,0,0,0.3)',
      glowAccent: '0 0 0 3px rgba(59,130,246,0.25)',
      textShadow: '0 1px 2px rgba(0,0,0,0.4)',
      headingTextShadow: '0 1px 3px rgba(0,0,0,0.5)',
      borderRadius: '12px',
      borderRadiusLg: '16px',
      borderRadiusSm: '8px',
      borderWidth: '1px',
      cardBorder: '1px solid #334155',
      inputBorder: '1px solid #475569',
      transition: 'all 0.15s ease',
    },
  },

  'pro-midnight': {
    id: 'pro-midnight',
    name: 'Midnight',
    description: 'True black for OLED screens',
    category: 'professional',
    preview: '🌑',
    colors: {
      bgPrimary: '#000000',
      bgSecondary: '#000000',
      bgCard: '#1a1a1a',
      bgCardSolid: '#1c1c1c',
      bgCardHover: '#282828',
      bgInput: '#0c0c0c',
      bgHover: 'rgba(59,130,246,0.2)',
      bgModal: '#000000',
      accent: '#3b82f6',
      accentLight: '#60a5fa',
      accentDark: '#2563eb',
      accentGlow: 'rgba(59,130,246,0.4)',
      success: '#22c55e',
      successBg: 'rgba(34,197,94,0.2)',
      danger: '#ef4444',
      dangerBg: 'rgba(239,68,68,0.2)',
      warning: '#eab308',
      warningBg: 'rgba(234,179,8,0.2)',
      info: '#3b82f6',
      infoBg: 'rgba(59,130,246,0.2)',
      mana: '#8b5cf6',
      manaBg: 'rgba(139,92,246,0.2)',
      textPrimary: '#fafafa',
      textSecondary: '#a1a1aa',
      textMuted: '#71717a',
      textOnAccent: '#ffffff',
      borderPrimary: '#2a2a2a',
      borderLight: '#1a1a1a',
      borderAccent: '#3b82f6',
      hpHigh: '#22c55e',
      hpMid: '#eab308',
      hpLow: '#ef4444',
      buffBg: 'rgba(34,197,94,0.25)',
      buffBorder: '#22c55e',
      buffText: '#86efac',
      debuffBg: 'rgba(239,68,68,0.25)',
      debuffBorder: '#ef4444',
      debuffText: '#fca5a5',
    },
    typography: {
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      headingFamily: 'Inter, sans-serif',
      monoFamily: '"JetBrains Mono", monospace',
    },
    effects: {
      cardShadow: '0 0 0 1px #2a2a2a',
      cardShadowHover: '0 0 0 1px #3b82f6, 0 0 20px rgba(59,130,246,0.15)',
      buttonShadow: '0 1px 2px rgba(0,0,0,0.8)',
      glowAccent: '0 0 0 2px rgba(59,130,246,0.5)',
      textShadow: '0 1px 2px rgba(0,0,0,0.6)',
      headingTextShadow: '0 1px 3px rgba(0,0,0,0.7)',
      borderRadius: '8px',
      borderRadiusLg: '12px',
      borderRadiusSm: '6px',
      borderWidth: '1px',
      cardBorder: '1px solid #2a2a2a',
      inputBorder: '1px solid #3f3f46',
      transition: 'all 0.1s ease',
    },
  },

  'eldritch-horror': {
    id: 'eldritch-horror',
    name: 'Eldritch Horror',
    description: 'Cosmic dread and unknowable terrors',
    category: 'fantasy',
    preview: '🐙',
    colors: {
      bgPrimary: 'linear-gradient(135deg, #0a0a0f 0%, #0d1018 50%, #080510 100%)',
      bgSecondary: '#060608',
      bgCard: 'linear-gradient(180deg, rgba(20,25,35,0.98) 0%, rgba(15,18,28,0.99) 100%)',
      bgCardSolid: '#141923',
      bgCardHover: '#1c2430',
      bgInput: 'rgba(12,15,22,0.95)',
      bgHover: 'rgba(120,180,140,0.15)',
      bgModal: 'rgba(0,0,0,0.95)',
      accent: '#78b48c',
      accentLight: '#a8d8b8',
      accentDark: '#4a8860',
      accentGlow: 'rgba(120,180,140,0.4)',
      success: '#78b48c',
      successBg: 'rgba(120,180,140,0.25)',
      danger: '#b84a68',
      dangerBg: 'rgba(184,74,104,0.25)',
      warning: '#b8a848',
      warningBg: 'rgba(184,168,72,0.25)',
      info: '#6888b8',
      infoBg: 'rgba(104,136,184,0.25)',
      mana: '#8868a8',
      manaBg: 'rgba(136,104,168,0.35)',
      textPrimary: '#c8d0d8',
      textSecondary: '#8898a8',
      textMuted: '#586878',
      textOnAccent: '#0a0a0f',
      borderPrimary: '#2a3848',
      borderLight: '#1a2530',
      borderAccent: '#78b48c',
      hpHigh: '#78b48c',
      hpMid: '#b8a848',
      hpLow: '#b84a68',
      buffBg: 'rgba(120,180,140,0.30)',
      buffBorder: '#78b48c',
      buffText: '#a8e8b8',
      debuffBg: 'rgba(184,74,104,0.30)',
      debuffBorder: '#b84a68',
      debuffText: '#e8a8b8',
    },
    typography: {
      fontFamily: '"Crimson Text", Georgia, serif',
      headingFamily: '"Crimson Text", serif',
      monoFamily: '"Fira Code", monospace',
    },
    effects: {
      cardShadow: '0 8px 32px rgba(0,0,0,0.7), 0 0 40px rgba(120,180,140,0.08)',
      cardShadowHover: '0 12px 40px rgba(0,0,0,0.8), 0 0 50px rgba(120,180,140,0.12)',
      buttonShadow: '0 2px 8px rgba(0,0,0,0.5)',
      glowAccent: '0 0 30px rgba(120,180,140,0.3)',
      textShadow: '0 1px 3px rgba(0,0,0,0.7)',
      headingTextShadow: '0 2px 6px rgba(0,0,0,0.8)',
      borderRadius: '6px',
      borderRadiusLg: '10px',
      borderRadiusSm: '4px',
      borderWidth: '2px',
      cardBorder: '2px solid #2a3848',
      inputBorder: '1px solid #1a2530',
      transition: 'all 0.3s ease',
    },
  },

  'high-contrast': {
    id: 'high-contrast',
    name: 'High Contrast',
    description: 'Maximum readability for accessibility',
    category: 'accessibility',
    preview: '👁',
    colors: {
      bgPrimary: '#000000',
      bgSecondary: '#000000',
      bgCard: '#1a1a1a',
      bgCardSolid: '#1a1a1a',
      bgCardHover: '#2a2a2a',
      bgInput: '#0a0a0a',
      bgHover: 'rgba(255,255,0,0.3)',
      bgModal: '#000000',
      accent: '#ffff00',
      accentLight: '#ffff66',
      accentDark: '#cccc00',
      accentGlow: 'rgba(255,255,0,0.5)',
      success: '#00ff00',
      successBg: 'rgba(0,255,0,0.25)',
      danger: '#ff0000',
      dangerBg: 'rgba(255,0,0,0.25)',
      warning: '#ffff00',
      warningBg: 'rgba(255,255,0,0.25)',
      info: '#00ffff',
      infoBg: 'rgba(0,255,255,0.25)',
      mana: '#00ffff',
      manaBg: 'rgba(0,255,255,0.25)',
      textPrimary: '#ffffff',
      textSecondary: '#ffffff',
      textMuted: '#cccccc',
      textOnAccent: '#000000',
      borderPrimary: '#ffffff',
      borderLight: '#888888',
      borderAccent: '#ffff00',
      hpHigh: '#00ff00',
      hpMid: '#ffff00',
      hpLow: '#ff0000',
      buffBg: 'rgba(0,255,0,0.35)',
      buffBorder: '#00ff00',
      buffText: '#00ff00',
      debuffBg: 'rgba(255,0,0,0.35)',
      debuffBorder: '#ff0000',
      debuffText: '#ff0000',
    },
    typography: {
      fontFamily: 'Arial, Helvetica, sans-serif',
      headingFamily: 'Arial, sans-serif',
      monoFamily: '"Courier New", Courier, monospace',
    },
    effects: {
      cardShadow: 'none',
      cardShadowHover: '0 0 0 3px #ffff00',
      buttonShadow: 'none',
      glowAccent: 'none',
      textShadow: 'none',
      headingTextShadow: 'none',
      borderRadius: '4px',
      borderRadiusLg: '4px',
      borderRadiusSm: '2px',
      borderWidth: '3px',
      cardBorder: '3px solid #ffffff',
      inputBorder: '2px solid #ffffff',
      transition: 'none',
    },
  },
};

// ============================================================================
// THEME VARIATIONS - 3+ variations per main theme
// Each variation overrides specific color properties
// ============================================================================

export const THEME_VARIATIONS = {
  'fantasy-classic': [
    { id: 'default', name: 'Classic' },
    { id: 'void', name: 'Void', colors: { 
      bgPrimary: '#010102', 
      bgSecondary: '#000001', 
      bgCardSolid: '#1a1810', 
      bgCardHover: '#2a2820', 
      textPrimary: '#d0c8b0', 
      textSecondary: '#a89870' 
    }},
  ],
  'fantasy-dark': [
    { id: 'default', name: 'Abyss' },
    { id: 'mystic', name: 'Mystic', colors: { bgPrimary: 'linear-gradient(135deg, #050008 0%, #0a0412 50%, #08060f 100%)', bgSecondary: '#030005', textPrimary: '#f4eeff', textSecondary: '#d0c0e8' }},
    { id: 'blood', name: 'Blood Magic', colors: { bgPrimary: 'linear-gradient(135deg, #100408 0%, #1c0810 50%, #140610 100%)', bgSecondary: '#080204', textPrimary: '#ffe0e8', textSecondary: '#e8a0b0', accent: '#ff4080', accentLight: '#ff70a0' }},
    { id: 'cosmic', name: 'Cosmic', colors: { bgPrimary: 'linear-gradient(135deg, #040818 0%, #081030 50%, #061028 100%)', bgSecondary: '#020410', textPrimary: '#e0f0ff', textSecondary: '#90c0f8', accent: '#60a0ff', accentLight: '#90c8ff' }},
  ],
  'fantasy-nature': [
    { id: 'default', name: 'Autumn' },
    { id: 'grove', name: 'Grove', colors: { 
      bgPrimary: 'linear-gradient(135deg, #040a04 0%, #081208 50%, #050f08 100%)', 
      bgSecondary: '#020502', 
      bgCardSolid: '#2d4630',
      bgCardHover: '#3a5a3e',
      textPrimary: '#e8f5e0', 
      textSecondary: '#b8d8a8',
      textMuted: '#7aa868',
      accent: '#4a9c5d',
      accentLight: '#7ddb8a',
      borderPrimary: '#3d7a45',
      borderLight: '#2a5530',
    }},
    { id: 'toxic', name: 'Toxic', colors: { bgPrimary: 'linear-gradient(135deg, #041004 0%, #082008 50%, #061806 100%)', bgSecondary: '#020802', textPrimary: '#c0ffc0', textSecondary: '#70e070', accent: '#40ff40', accentLight: '#80ff80' }},
    { id: 'frost', name: 'Frost', colors: { bgPrimary: 'linear-gradient(135deg, #040a10 0%, #081420 50%, #061018 100%)', bgSecondary: '#020508', textPrimary: '#e8f8ff', textSecondary: '#a0d8f0', accent: '#60c8e8', accentLight: '#90e0f8' }},
  ],
  'sunset-dusk': [
    { id: 'default', name: 'Classic' },
    { id: 'violet', name: 'Violet', colors: { bgPrimary: 'linear-gradient(135deg, #0c0410 0%, #140820 50%, #100618 100%)', bgSecondary: '#060208', textPrimary: '#f8f0ff', textSecondary: '#d8c0f0', accent: '#c880ff', accentLight: '#e0a8ff' }},
    { id: 'inferno', name: 'Inferno', colors: { bgPrimary: 'linear-gradient(135deg, #180404 0%, #280808 50%, #200606 100%)', bgSecondary: '#0c0202', textPrimary: '#fff0e0', textSecondary: '#f0c090', accent: '#ff7030', accentLight: '#ff9050' }},
    { id: 'neon', name: 'Neon', colors: { bgPrimary: 'linear-gradient(135deg, #080420 0%, #140830 50%, #100628 100%)', bgSecondary: '#040210', textPrimary: '#f8e0ff', textSecondary: '#e0a0f0', accent: '#ff40e0', accentLight: '#ff80f0' }},
  ],
  'ocean-depths': [
    { id: 'default', name: 'Classic' },
    { id: 'abyss', name: 'Abyss', colors: { bgPrimary: 'linear-gradient(135deg, #040210 0%, #080418 50%, #060314 100%)', bgSecondary: '#020108', textPrimary: '#d8e0ff', textSecondary: '#90a8e0', accent: '#8080ff', accentLight: '#a8a8ff' }},
    { id: 'tropical', name: 'Tropical', colors: { bgPrimary: 'linear-gradient(135deg, #021008 0%, #042010 50%, #03180c 100%)', bgSecondary: '#010804', textPrimary: '#d0fff0', textSecondary: '#70f0c8', accent: '#40f0a0', accentLight: '#80f8c0' }},
    { id: 'arctic', name: 'Arctic', colors: { bgPrimary: 'linear-gradient(135deg, #081018 0%, #102030 50%, #0c1828 100%)', bgSecondary: '#040810', textPrimary: '#f8ffff', textSecondary: '#c8e8f8', accent: '#a0e0ff', accentLight: '#c8f0ff' }},
  ],
  'northern-lights': [
    { id: 'default', name: 'Classic' },
    { id: 'solar', name: 'Solar Storm', colors: { bgPrimary: 'linear-gradient(135deg, #100408 0%, #200c18 50%, #180810 100%)', bgSecondary: '#080204', textPrimary: '#fff0f8', textSecondary: '#f0a8c8', accent: '#ff60b0', accentLight: '#ff90d0' }},
    { id: 'forest', name: 'Forest', colors: { bgPrimary: 'linear-gradient(135deg, #020c04 0%, #041808 50%, #031406 100%)', bgSecondary: '#010602', textPrimary: '#d8ffe8', textSecondary: '#80f0a8', accent: '#40ff70', accentLight: '#80ffa0' }},
    { id: 'frozen', name: 'Frozen', colors: { bgPrimary: 'linear-gradient(135deg, #040c18 0%, #082030 50%, #061828 100)', bgSecondary: '#020610', textPrimary: '#f0ffff', textSecondary: '#a8e8ff', accent: '#60d8ff', accentLight: '#a0f0ff' }},
  ],
  'copper-teal': [
    { id: 'default', name: 'Classic' },
    { id: 'forge', name: 'Forge', colors: { bgPrimary: 'linear-gradient(135deg, #140804 0%, #201008 50%, #180a06 100%)', bgSecondary: '#0a0402', textPrimary: '#fff8e0', textSecondary: '#f0c890', accent: '#ff8040', accentLight: '#ffa060' }},
    { id: 'patina', name: 'Patina', colors: { bgPrimary: 'linear-gradient(135deg, #041010 0%, #082020 50%, #061818 100%)', bgSecondary: '#020808', textPrimary: '#e0ffff', textSecondary: '#90e8e8', accent: '#40d8d8', accentLight: '#70f0f0' }},
    { id: 'rust', name: 'Rust', colors: { bgPrimary: 'linear-gradient(135deg, #0c0604 0%, #180c08 50%, #100806 100%)', bgSecondary: '#060302', textPrimary: '#f0e0d0', textSecondary: '#c8a080', bgCardSolid: '#302418', bgCardHover: '#403420' }},
  ],
  'sakura': [
    { id: 'default', name: 'Classic' },
    { id: 'spring', name: 'Spring', colors: { bgPrimary: 'linear-gradient(135deg, #061008 0%, #0c2010 50%, #08180c 100%)', bgSecondary: '#030804', textPrimary: '#e8ffe8', textSecondary: '#a0f0a0', accent: '#60e060', accentLight: '#90f890' }},
    { id: 'sunset', name: 'Sunset', colors: { bgPrimary: 'linear-gradient(135deg, #140808 0%, #201010 50%, #180c0c 100%)', bgSecondary: '#0a0404', textPrimary: '#fff0e8', textSecondary: '#f8c8a0', accent: '#f89060', accentLight: '#ffb080' }},
    { id: 'moonlit', name: 'Moonlit', colors: { bgPrimary: 'linear-gradient(135deg, #060810 0%, #0c1020 50%, #080c18 100)', bgSecondary: '#030408', textPrimary: '#f0f8ff', textSecondary: '#b0d0f0', accent: '#a0c0ff', accentLight: '#c0d8ff' }},
  ],
  'royal-court': [
    { id: 'default', name: 'Classic' },
    { id: 'crimson', name: 'Crimson', colors: { bgPrimary: 'linear-gradient(135deg, #180408 0%, #280810 50%, #200610 100%)', bgSecondary: '#0c0204', textPrimary: '#fff0f0', textSecondary: '#f0c0c0', accent: '#e07070', accentLight: '#f09090' }},
    { id: 'obsidian', name: 'Obsidian', colors: { bgPrimary: '#020204', bgSecondary: '#010102', bgCardSolid: '#181820', bgCardHover: '#282830', textPrimary: '#e0e0e8', textSecondary: '#a0a0b0' }},
    { id: 'emerald', name: 'Emerald', colors: { bgPrimary: 'linear-gradient(135deg, #040c08 0%, #081810 50%, #06140c 100)', bgSecondary: '#020604', textPrimary: '#e8fff0', textSecondary: '#90e8b0', accent: '#50d880', accentLight: '#80f0a8' }},
  ],
  'ember-frost': [
    { id: 'default', name: 'Classic' },
    { id: 'volcano', name: 'Volcano', colors: { bgPrimary: 'linear-gradient(135deg, #200404 0%, #300808 50%, #280606 100%)', bgSecondary: '#100202', textPrimary: '#fff8e8', textSecondary: '#ffc8a0', accent: '#ff5020', accentLight: '#ff8050', bgCardSolid: '#402018', bgCardHover: '#503020' }},
    { id: 'glacier', name: 'Glacier', colors: { bgPrimary: 'linear-gradient(135deg, #040c18 0%, #082030 50%, #061828 100%)', bgSecondary: '#020610', textPrimary: '#e8ffff', textSecondary: '#a0e8ff', accent: '#40c8ff', accentLight: '#80e0ff', bgCardSolid: '#102838', bgCardHover: '#183848' }},
    { id: 'chaos', name: 'Chaos', colors: { bgPrimary: 'linear-gradient(135deg, #100410 0%, #200820 50%, #180618 100%)', bgSecondary: '#080208', textPrimary: '#ffe8ff', textSecondary: '#e0a0e0', accent: '#d060d0', accentLight: '#e890e8' }},
  ],
  'desert-oasis': [
    { id: 'default', name: 'Classic' },
    { id: 'scorched', name: 'Scorched', colors: { bgPrimary: 'linear-gradient(135deg, #180a04 0%, #281408 50%, #201006 100%)', bgSecondary: '#0c0502', textPrimary: '#fffce0', textSecondary: '#f0d890', accent: '#e8b040', accentLight: '#f8d060' }},
    { id: 'night', name: 'Night', colors: { bgPrimary: 'linear-gradient(135deg, #040610 0%, #081020 50%, #060c18 100%)', bgSecondary: '#020308', textPrimary: '#e8f0ff', textSecondary: '#a8c8f0', accent: '#7090d0', accentLight: '#90b0e8' }},
    { id: 'mirage', name: 'Mirage', colors: { bgPrimary: 'linear-gradient(135deg, #0c080c 0%, #181018 50%, #140c14 100%)', bgSecondary: '#060406', textPrimary: '#f8f0f8', textSecondary: '#d8c0d8', accent: '#c090c0', accentLight: '#e0b0e0' }},
  ],
  'enchanted-forest': [
    { id: 'default', name: 'Classic' },
    { id: 'biolume', name: 'Biolume', colors: { bgPrimary: 'linear-gradient(135deg, #020a06 0%, #041808 50%, #031206 100%)', bgSecondary: '#010503', textPrimary: '#c0fff0', textSecondary: '#60f0c0', accent: '#30ffa0', accentLight: '#70ffc0' }},
    { id: 'twilight', name: 'Twilight', colors: { bgPrimary: 'linear-gradient(135deg, #0a0610 0%, #140c20 50%, #100818 100%)', bgSecondary: '#050308', textPrimary: '#f0e8ff', textSecondary: '#c8a8f0', accent: '#a070e8', accentLight: '#c098f8' }},
    { id: 'ancient', name: 'Ancient', colors: { bgPrimary: 'linear-gradient(135deg, #0a0804 0%, #141008 50%, #100c06 100)', bgSecondary: '#050402', textPrimary: '#f0e8d8', textSecondary: '#c8b890', bgCardSolid: '#283020', bgCardHover: '#384030' }},
  ],
  'mint-chocolate': [
    { id: 'default', name: 'Classic' },
    { id: 'dark', name: 'Dark', colors: { bgPrimary: '#020202', bgSecondary: '#010101', bgCardSolid: '#201810', bgCardHover: '#302820', textPrimary: '#f0e8e0', textSecondary: '#c0b0a0' }},
    { id: 'fresh', name: 'Fresh', colors: { bgPrimary: 'linear-gradient(135deg, #021008 0%, #042010 50%, #031808 100%)', bgSecondary: '#010804', textPrimary: '#d0fff0', textSecondary: '#80f8d0', accent: '#40f8a0', accentLight: '#80ffc0' }},
    { id: 'caramel', name: 'Caramel', colors: { bgPrimary: 'linear-gradient(135deg, #120a04 0%, #1c1006 50%, #160c05 100%)', bgSecondary: '#090502', textPrimary: '#fff8e0', textSecondary: '#e8d0a0', accent: '#e0a050', accentLight: '#f0c080' }},
  ],
  'pro-dark': [
    { id: 'default', name: 'Pitch' },
    { id: 'navy', name: 'Navy', colors: { bgPrimary: '#080d18', bgSecondary: '#050a12', bgCard: '#1a2538', bgCardSolid: '#1e2d42', bgCardHover: '#283a52', borderPrimary: '#334155', borderLight: '#1e293b' }},
    { id: 'marine', name: 'Marine', colors: { bgPrimary: '#041018', bgSecondary: '#020810', textPrimary: '#e0f4ff', textSecondary: '#90c8e8', accent: '#40a0d8', accentLight: '#70c0f0' }},
    { id: 'wine', name: 'Wine', colors: { bgPrimary: '#100810', bgSecondary: '#080408', textPrimary: '#f8f0f4', textSecondary: '#d8b0c8', accent: '#c870a0', accentLight: '#e098c0' }},
  ],
  'pro-midnight': [
    { id: 'default', name: 'Classic' },
    { id: 'ember', name: 'Ember', colors: { bgPrimary: '#020100', bgSecondary: '#010100', accent: '#ff5030', accentLight: '#ff8060', accentGlow: 'rgba(255,80,48,0.5)', textSecondary: '#c09080' }},
    { id: 'matrix', name: 'Matrix', colors: { bgPrimary: '#000200', bgSecondary: '#000100', accent: '#00ff40', accentLight: '#60ff80', accentGlow: 'rgba(0,255,64,0.5)', textPrimary: '#c0ffc8', textSecondary: '#70c878' }},
    { id: 'cyber', name: 'Cyber', colors: { bgPrimary: '#000204', bgSecondary: '#000102', accent: '#00d0ff', accentLight: '#60e8ff', accentGlow: 'rgba(0,208,255,0.5)', textPrimary: '#d8f8ff', textSecondary: '#80c8e0' }},
  ],
  'eldritch-horror': [
    { id: 'default', name: 'Cthulhu' },
    { id: 'void', name: 'Void', colors: { 
      bgPrimary: '#000000', 
      bgSecondary: '#000000', 
      bgCardSolid: '#0a0a10',
      bgCardHover: '#101018',
      textPrimary: '#a0a0b8', 
      textSecondary: '#6868a0',
      accent: '#6858a8',
      accentLight: '#9080d0',
      accentGlow: 'rgba(104,88,168,0.4)',
    }},
    { id: 'madness', name: 'Madness', colors: { 
      bgPrimary: 'linear-gradient(135deg, #10080a 0%, #0a1008 50%, #080810 100%)', 
      bgSecondary: '#080808',
      textPrimary: '#d8d0a0', 
      textSecondary: '#a8a060',
      accent: '#c8b830',
      accentLight: '#e8d850',
      accentGlow: 'rgba(200,184,48,0.4)',
      warning: '#c8b830',
    }},
    { id: 'deep-one', name: 'Deep One', colors: { 
      bgPrimary: 'linear-gradient(135deg, #04080a 0%, #061012 50%, #081418 100%)', 
      bgSecondary: '#040808',
      bgCardSolid: '#0c1820',
      bgCardHover: '#142028',
      textPrimary: '#b0d0d8', 
      textSecondary: '#6898a8',
      accent: '#40a8a0',
      accentLight: '#68d0c8',
      accentGlow: 'rgba(64,168,160,0.4)',
      mana: '#4888a8',
      borderPrimary: '#204048',
    }},
    { id: 'cosmic', name: 'Cosmic', colors: { 
      bgPrimary: 'linear-gradient(135deg, #080410 0%, #100820 50%, #0c0618 100%)', 
      bgSecondary: '#060410',
      bgCardSolid: '#181028',
      bgCardHover: '#201838',
      textPrimary: '#d8d0f0', 
      textSecondary: '#a090d0',
      accent: '#a070e0',
      accentLight: '#c8a0ff',
      accentGlow: 'rgba(160,112,224,0.5)',
      mana: '#8060c0',
      borderPrimary: '#3a2860',
    }},
  ],
  'high-contrast': [
    { id: 'default', name: 'Classic' },
    { id: 'amber', name: 'Amber', colors: { accent: '#ffa000', accentLight: '#ffc040', warning: '#ffa000', borderAccent: '#ffa000', textOnAccent: '#000000' }},
    { id: 'matrix', name: 'Matrix', colors: { accent: '#00ff00', accentLight: '#80ff80', warning: '#00ff00', borderAccent: '#00ff00', textPrimary: '#00ff00', textSecondary: '#00c000', success: '#00ff00' }},
  ],
};

// Theme display order (matching demo)
export const THEME_ORDER = [
  'fantasy-classic', 'northern-lights', 'sunset-dusk', 'royal-court', 
  'enchanted-forest', 'desert-oasis', 'sakura', 'mint-chocolate', 'copper-teal',
  'ocean-depths', 'ember-frost', 'fantasy-dark', 'eldritch-horror', 'fantasy-nature',
  'pro-dark', 'pro-midnight'
];

// ============================================================================
// LAYOUT DENSITY OPTIONS
// ============================================================================

export const DENSITY_MODES = {
  'compact': {
    id: 'compact', name: 'Compact', description: 'Maximum information density', icon: '▪️',
    spacing: { cardPadding: '12px', cardGap: '10px', sectionGap: '10px', itemGap: '4px' },
    typography: { baseFontSize: '13px', headingSize: '1rem', labelSize: '0.7rem', badgeSize: '0.65rem' },
    layout: { gridMinWidth: '220px', badgePadding: '3px 8px', buttonPadding: '6px 10px', inputPadding: '8px' },
  },
  'comfortable': {
    id: 'comfortable', name: 'Comfortable', description: 'Balanced readability', icon: '◾',
    spacing: { cardPadding: '20px', cardGap: '16px', sectionGap: '16px', itemGap: '8px' },
    typography: { baseFontSize: '15px', headingSize: '1.2rem', labelSize: '0.8rem', badgeSize: '0.75rem' },
    layout: { gridMinWidth: '280px', badgePadding: '5px 12px', buttonPadding: '10px 16px', inputPadding: '12px' },
  },
  'spacious': {
    id: 'spacious', name: 'Spacious', description: 'Easy reading', icon: '⬛',
    spacing: { cardPadding: '28px', cardGap: '24px', sectionGap: '24px', itemGap: '12px' },
    typography: { baseFontSize: '17px', headingSize: '1.4rem', labelSize: '0.85rem', badgeSize: '0.8rem' },
    layout: { gridMinWidth: '320px', badgePadding: '6px 14px', buttonPadding: '12px 20px', inputPadding: '14px' },
  },
};


// ============================================================================
// applyVariation — pulled directly from main app
// ============================================================================
export const applyVariation = (baseTheme, variationId) => {
  if (!variationId || variationId === 'default') return baseTheme;
  const variations = THEME_VARIATIONS[baseTheme.id] || [];
  const variation = variations.find(v => v.id === variationId);
  if (!variation || !variation.colors) return baseTheme;
  return { ...baseTheme, colors: { ...baseTheme.colors, ...variation.colors } };
};
